/* eslint-disable no-param-reassign */
/**
 * Looks for any oembeds that should have dynamic heights and applies
 * selector for dynamicIframe component.
 */
export default function () {
  const oEmbeds = document.querySelectorAll(
    'iframe.wp-embedded-content[src*="datacenter.prb.org"]'
  );

  Array.prototype.forEach.call(oEmbeds, (oEmbed) => {
    // Create new iframe with embedded content's properties
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', oEmbed.getAttribute('src'));
    iframe.classList.add('prb-embed-iframe');
    iframe.dataset.component = 'dynamicIframe';

    // Store reference to parent
    const parent = oEmbed.parentNode;

    // Always size this kind of element as full
    parent.classList.add('article-media--full');

    // Create embed wrapper
    const embedWrapper = document.createElement('div');
    embedWrapper.classList.add('embed-wrapper');

    // Delete reference to original embed
    oEmbed.remove();

    // Store new embed inside parent
    parent.appendChild(embedWrapper);
    embedWrapper.appendChild(iframe);
  });
}



// WEBPACK FOOTER //
// ./client/js/article/applySelectorToOEmbeds.js